/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services */

/**
 * Renders Scroll To Top Component
 *
 * @returns {ReactElement} - Scroll To Top Component
 */
export default function ScrollToTop({pageConfig}) {
  const [isVisible, setIsVisible] = useState(false);

  // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      let pageYOffsetThreshold = 500
      if (pageConfig?.pageName === 'margazhisadhananew') {
        pageYOffsetThreshold = 2300
      }
      if (window.pageYOffset > pageYOffsetThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // scroll-to-top classes: fixed, bottom:0, right:0
  return (
    <>
      <Box>
        {isVisible && (
          <Box
            pos="fixed"
            w="50px"
            h="50px"
            right="30px"
            bottom="65px"
            borderRadius="25px"
            bgColor="rgb(0 0 0 / 50%)"
            cursor="pointer"
            zIndex="10"
            onClick={scrollToTop}
          >
          
            <LazyLoadImageComponent
              w="30px"
              transform="rotate(-180deg)"
              margin="7px auto auto"
              display="block !important"
              src={`${config.staticPath}/assets/images/chevron-down-white.svg`}
              alt="Go to top"
            />
          </Box>
        )}
      </Box>
    </>
  );
}
